import { AnswerTarget } from "@/types/questionnaire/models"
import { classNames } from "@/utils/classNames"
import { OptionClearSelectionButton } from "../PdfAnswerItem/OptionClearSelectionButton"

interface RadioInputOptionProps {
  answerTargets: AnswerTarget[]
  value: string
  onChange: (value: string, cellAddress: string) => void
  onClear: (cellAddress: string) => void
  hasError: boolean
  hasWarning: boolean
  responsePairId: string | null
}

export const RadioInputOption: React.FC<RadioInputOptionProps> = ({
  answerTargets,
  value,
  onChange,
  onClear,
  responsePairId,
}) => {
  const hasMultipleAnswerTargets = answerTargets.length > 1

  const handleChange = (optionValue: string, cellAddress: string) => {
    onChange(optionValue, cellAddress)
  }

  return (
    <>
      {answerTargets.map((answerTarget, i) => {
        if (!answerTarget) {
          return null
        }

        const allowedValues = answerTarget.allowedValues || []
        const cellAddress = answerTarget.addr

        return (
          <div
            className="space-y-XS px-4 py-2"
            key={`${answerTarget.addr}-${i}`}
          >
            {hasMultipleAnswerTargets ? <h5>{answerTarget.label}</h5> : null}

            {allowedValues.map((optionValue) => {
              const isChecked = value === optionValue

              return (
                <div
                  key={`${answerTarget.addr}-${optionValue}`}
                  className="flex items-center justify-between"
                >
                  <label
                    className={classNames(
                      "cursor-pointer items-center gap-XS",
                      "flex hover:bg-grey2",
                    )}
                  >
                    <input
                      type="radio"
                      name={`${responsePairId}-boolean-option-${cellAddress}`}
                      checked={isChecked}
                      onChange={() => handleChange(optionValue, cellAddress)}
                      className="h-4 w-4 cursor-pointer accent-primary"
                    />
                    <span className="text-white">{optionValue}</span>
                  </label>

                  {isChecked && (
                    <OptionClearSelectionButton
                      onClear={() => {
                        onClear(cellAddress)
                      }}
                    />
                  )}
                </div>
              )
            })}
          </div>
        )
      })}
    </>
  )
}
